<template>
    <div class="section upcoming-features">
        <div class="container narrow-container">

            <div class="back-option" v-on:click="$router.go(-1)">
            <!-- svg icon start -->
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="20" height="20"
                viewBox="0 0 224 224"
                style=" fill:#A59DC4;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,224v-224h224v224z" fill="none"></path><g fill="#A59DC4"><g id="surface1"><path d="M112,21c-50.17578,0 -91,40.82422 -91,91c0,50.17578 40.82422,91 91,91c50.17578,0 91,-40.82422 91,-91c0,-50.17578 -40.82422,-91 -91,-91zM112,35c42.60157,0 77,34.39844 77,77c0,42.60157 -34.39843,77 -77,77c-42.60156,0 -77,-34.39843 -77,-77c0,-42.60156 34.39844,-77 77,-77zM106.96875,67.15625l-44.84375,44.84375l44.84375,44.84375l10.0625,-9.84375l-28,-28h71.96875v-14h-71.96875l28,-28z"></path></g></g></g></svg>
                <!-- svg icon end -->
                <p class="light-text disclaimer-body">Previous Page</p>
            </div>

            <div class="intro">
                <h3 class="white-text">Upcoming Features</h3>
                <p class="light-text">Slumber Bear is continually in development and being improved. Below are a few of the features I plan to add in soon.</p>
            </div>

            <div class="feature-list">
                <ul class="accent-text">
                    <li><p class="light-text small-body">Add Ability to Schedule to various popular Calendars (Google, Fantastical, OSX, etc). 📅</p></li>
                    <li><p class="light-text small-body">Ability to sync with Google Home, Alexa, or other home-device. 🔈</p></li>
                    <li><p class="light-text small-body">Add more sleep cycles. 🛌</p></li>
                    <li><p class="light-text small-body">Add more information about each cycle. ℹ</p></li>
                    <li><p class="light-text small-body">Add a visual example timeline for reference. ⏰</p></li>
                    <li><p class="light-text small-body">A guide/tips on how to best adapt to new sleeping cycles. 📖</p></li>
                    <li><p class="light-text small-body">Indicators/Ratings on how difficult a cycle is to adapt to. 😴</p></li>
                    <li><p class="light-text small-body">"Commit" to a schedule, and appear as a in a list of users actively trying a schedule. ✋</p></li>
                    <li><p class="light-text small-body">Leave reviews/experience with specific schedules. 📝</p></li>
                </ul>
            </div>

            <div class="suggest-more">
                <p class="light-text small-body">Got some ideas of your own that you think would be beneficial to other users?</p>
                <p class="light-text small-body">I would love to hear it, drop me (<a href="https://twitter.com/_kprkr">Kieran Parker</a>) a tweet with your idea.</p>
                <p class="light-text small-body">Or, just stop by and say hi! 👋</p>
            </div>

            <div class="twitter-sharing">
              <social-sharing 
              v-bind:url="this.url"
              v-bind:title="this.title"
              description=""
              quote=""
              hashtags="sleep, productivity, startup, idea"
              twitter-user=""
              inline-template>
                <div>
                    <network network="twitter">
                      <button class="twitter-share-button">
                        <span class="twitter-text">
                          <img src="@/assets/twitter-logo-silhouette.svg" class="twitter-icon">
                            Share Your Idea
                        </span>
                      </button>
                    </network>
                </div>
              </social-sharing>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UpcomingFeatures",

    metaInfo: {
        title: 'Upcoming Features',
        // override the parent template and just use the above title only
        titleTemplate: '%s | Slumber Bear',
        meta: [
            {itemprop: 'name', content: 'Upcoming Features | Slumber Bear'},
            {itemprop: 'description', content: 'Slumber Bear is continually in development and being improved. Below are a few of the features I plan to add in soon. If you have any ideas on how it can be improved, we are all ears!'},
            {itemprop: 'image', content: 'https://i.imgur.com/lEHqYJ4.jpg'}
        ]
    },

    data() {
        return {
            title:
            "Hey @_kprkr I have an idea for Slumber Bear...💡"
        };
    },
};


</script>

<style lang="scss">
@import "@/styles/global.scss";

.upcoming-features {
    background-color: $main-colour;
    padding: 160px 0px;
}

.upcoming-features .intro p {
    margin-top: 10px;
    width: 80%;
}

.upcoming-features .feature-list {
    margin-top: 50px;
    margin-bottom: 50px;
}

.upcoming-features ul {
    margin-right: 0;
    padding-left: 0;
    list-style: none;
}

.upcoming-features ul > li {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 10px 0;
}

.upcoming-features ul li:before {
    content: '';
    border: 1px solid $accent-colour;
    border-radius: 100%;
    width: 5px;
    height: 5px;
    display: inline-block;
    padding: 1px;
    // line-height: 1.0;
    margin-right: 16px;
}

.upcoming-features a:hover {
    color: $accent-colour;
    text-decoration: underline;
}

</style>
